import { SECTION_TYPES } from '@opengov/stories-shared/constants';
import React from 'react';

import { ISettings, IStoriesSettingsMessages } from '../../../../types';
import { ColorPicker } from '../../StoriesPage/ColorPicker';

import styles from './ColorSelectors.scss';

export interface IColorSelectorsProps {
  settings: ISettings;
  messages: IStoriesSettingsMessages;
  updateSettingsProps(newSettingsProps: Partial<ISettings>): any;
}

export class ColorSelectors extends React.Component<IColorSelectorsProps> {
  onAddColor = (section: string, subSection: string) => (color: string) => {
    const {
      settings: { brand },
      updateSettingsProps
    } = this.props;
    const swatch = [...brand.colors[section][subSection].swatch];

    swatch.push(color);

    const colors = {
      ...brand.colors,
      [section]: {
        ...brand.colors[section],
        [subSection]: {
          ...brand.colors[section][subSection],
          swatch
        }
      }
    };

    updateSettingsProps({ brand: { ...brand, colors } });
  };

  onRemoveColor = (section: string, subSection: string) => (color: string) => {
    const {
      settings: { brand },
      updateSettingsProps
    } = this.props;
    const swatch = [...brand.colors[section][subSection].swatch];

    const index = swatch.indexOf(color);
    if (index > -1) swatch.splice(index, 1);

    const colors = {
      ...brand.colors,
      [section]: {
        ...brand.colors[section],
        [subSection]: {
          ...brand.colors[section][subSection],
          swatch
        }
      }
    };

    updateSettingsProps({ brand: { ...brand, colors } });
  };

  onUpdateActiveColor = (section: string, subSection: string) => (
    event: React.MouseEvent<HTMLElement>,
    color: string
  ) => {
    event.preventDefault();
    const {
      settings: { brand },
      updateSettingsProps
    } = this.props;
    const colors = {
      ...brand.colors,
      [section]: {
        ...brand.colors[section],
        [subSection]: {
          ...brand.colors[section][subSection],
          active: color
        }
      }
    };

    updateSettingsProps({ brand: { ...brand, colors } });
  };

  renderColorSwatchSections() {
    const {
      messages,
      settings: {
        brand: { colors }
      }
    } = this.props;

    // Loop through header, body, footer color sections and render
    // ColorSwatchGroup for both background and font color swatches
    return SECTION_TYPES.map((section, i) => (
      <div className={styles.colorGroup} key={i} data-test="color-group">
        <h2>{messages[section]}</h2>

        <ColorPicker
          isSettings={true}
          isEditable={true}
          label={messages.backgroundColor}
          colorSwatch={colors[section].background.swatch}
          activeColor={colors[section].background.active}
          onAddColor={this.onAddColor(section, 'background')}
          onRemoveColor={this.onRemoveColor(section, 'background')}
          onColorClick={this.onUpdateActiveColor(section, 'background')}
        />

        <ColorPicker
          isSettings={true}
          isEditable={true}
          label={messages.fontColor}
          colorSwatch={colors[section].font.swatch}
          activeColor={colors[section].font.active}
          onAddColor={this.onAddColor(section, 'font')}
          onRemoveColor={this.onRemoveColor(section, 'font')}
          onColorClick={this.onUpdateActiveColor(section, 'font')}
        />
      </div>
    ));
  }

  render() {
    const { messages } = this.props;

    return (
      <div className={styles.colorsSection}>
        <div className={styles.headerContainer}>
          <h1 className={styles.header}>{messages.colors}</h1>
          <p>{messages.colorSelectorsText}</p>
        </div>

        {this.renderColorSwatchSections()}
      </div>
    );
  }
}
